import {
  SHARE_FOLDER_SUCCESS,
  TOGGLE_DETAILS_LOADING_STATUS,
  UPDATE_FOLDER_NAME,
  UPDATE_FOLDER_PREVIEW_DETAILS,
  UPDATE_PREVIEW_FOLDER_SHARE_STATUS,
  UPDATE_VIDEO_NAME,
} from 'constants/actions';

const DEFAULT_PREVIEW_PANEL_STATE = {
  id: '',
  entity_name: '',
  owner_avatars: [],
  owner_fname: '',
  owner_lname: '',
  recentVideos: [],
  total_reactions: 0,
  total_comments: 0,
  thumnail: '',
  total_views: 0,
  distinct_views: 0,
  created_at: '',
  description: '',
  knownUserViews: [],
  folderIsShared: false,
  previewDetailsLoading: false,
  videoProperties: {},
  totalVideos: 0,
  totalSubfolders: 0,
};

const previewPanelReducer = (state = DEFAULT_PREVIEW_PANEL_STATE, action) => {
  switch (action.type) {
    case SHARE_FOLDER_SUCCESS:
      return {
        ...state,
        folderIsShared:
          state.id === action.folderId ? true : state.folderIsShared,
      };
    case TOGGLE_DETAILS_LOADING_STATUS:
      return {
        ...DEFAULT_PREVIEW_PANEL_STATE,
        previewDetailsLoading: action.isLoading,
      };
    case UPDATE_FOLDER_PREVIEW_DETAILS:
      return {
        ...state,
        id: action.id,
        entity_name: action.name,
        owner_avatars: [...action.owner.avatars],
        owner_fname: action.owner.first_name,
        owner_lname: action.owner.last_name,
        recentVideos: [...action.recentVideos],
        totalSubfolders: action.totalSubfolders,
        folderIsShared: action.shared,
        previewDetailsLoading: false,
        totalVideos: action.totalVideos,
      };
    case UPDATE_PREVIEW_FOLDER_SHARE_STATUS:
      return {
        ...state,
        folderIsShared: action.isShared,
      };
    case UPDATE_VIDEO_NAME:
      return {
        ...state,
        entity_name:
          state.id === action.id ? action.newName : state.entity_name,
      };
    case UPDATE_FOLDER_NAME:
      return {
        ...state,
        entity_name:
          state.id === action.id ? action.newName : state.entity_name,
      };
    default:
      return state;
  }
};

export default previewPanelReducer;
